const freeShippingVariantId = window.theme.freeShippingHollowVariantId;

//If the cart is under the free shipping threshold but would have been over if they hadn't ordered products via layaway, ensure the cart has a 'Free shipping' hollow product which will be used to give them free shipping via a custom shipping rate specific to the 'Free shipping' hollow product

const getFreeShippingHollowProductStatus = async (obj) => {

    let { cart, keysOfProductsBeingRemoved, productsBeingAdded } = obj;

    try {
        if (!cart) {
            // Get current cart state
            const cartResponse = await fetch('/cart.js');
            cart = await cartResponse.json();
        }

        //If products are about to be added to the cart, add them into the calculations regarding whether the free shipping product should be added to the cart
        if (productsBeingAdded?.length) {
            productsBeingAdded.forEach((item) => {
                if (item?.final_price) {
                    cart.total_price += item.final_price;
                    cart.items.push(item);
                }
            })
        }

        //If products are about to be removed from the cart, remove them from the calculations regarding whether the free shipping product should be added to the cart  as we want to know what the cart will be after their removal
        if (keysOfProductsBeingRemoved?.length) {
            cart.items.forEach((item) => {
                if (item.key && keysOfProductsBeingRemoved?.includes(item.key) && item?.final_price) {
                    cart.total_price -= item.final_price;
                }
            })
        }

        const numberOfInstallments = 3;

        const currencyStr = window.Shopify.currency.active;

        const thresholdMap = {
            //If using a currency with a specific free shipping threshold set in the settings, use that as the minimum
            USD: window.theme.freeShippingThresholds.usd * 100,
            EUR: window.theme.freeShippingThresholds.eur * 100,
            CAD: window.theme.freeShippingThresholds.cad * 100,
            AUD: window.theme.freeShippingThresholds.aud * 100,

            //Else the currency is UK (or a region with a custom free shipping threshold) so use the standard converison rate
            default: window.theme.freeShippingThresholds.default * 100 * window.Shopify.currency.rate
        };

        const minSpendInSubUnits = thresholdMap[currencyStr] || thresholdMap.default;

        // Check if the free shipping hollow product is in cart already
        const hollowProductInCart = cart.items.find(item =>
            item.variant_id === freeShippingVariantId
        );

        const keyForHollowProductInCart = hollowProductInCart ? hollowProductInCart.key : null;

        let totalAfterLayawayDiscountInSubUnits = 0;

        // Work out how much the order is after the layaway 'discounts'
        let cartHasALayawayProduct = false;
        cart.items.forEach((item) => {
            //If the item is in the process of being removed, don't count towards the cart total as we want to know what the cart will be after their removal
            if (item.key && keysOfProductsBeingRemoved?.includes(item.key)) return;

            if (item.properties?.[window.theme.layawayText]) {
                cartHasALayawayProduct = true;
                totalAfterLayawayDiscountInSubUnits += item.final_price / numberOfInstallments
            } else {
                totalAfterLayawayDiscountInSubUnits += item.final_price
            }
        })

        //Apply hollow product if the total price is over but the subtotal (What the price is after layaway's 'discounts') is under the threshold
        if (cartHasALayawayProduct && cart.total_price > minSpendInSubUnits && totalAfterLayawayDiscountInSubUnits <= minSpendInSubUnits) {
            return { keyForHollowProductInCart: keyForHollowProductInCart, shouldBeInCart: true }
        } else {
            return { keyForHollowProductInCart: keyForHollowProductInCart, shouldBeInCart: false }
        }
    } catch (error) {
        console.error('Error handling cart:', error);
    }
}

const addFreeShippingHollowProduct = async () => {
    const formData = {
        items: [{
            id: freeShippingVariantId,
            quantity: 1,
            properties: {
                // Mark as _add-on so it doesn't count as a standard item to the code which removes all add-ons from the cart if there are no standard items left in the cart
                '_add-on': true
            }
        }]
    };

    const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    });

    const result = await addResponse.json();

    if (!addResponse.ok) {
        throw new Error(result.description || 'Failed to add free shipping product');
    }
}

const removeFreeShippingHollowProduct = async (keyForHollowProductInCart) => {
    const removeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: keyForHollowProductInCart,
            quantity: 0
        })
    });

    const result = await removeResponse.json();

    if (!removeResponse.ok) {
        throw new Error(result.description || 'Failed to remove free shipping product');
    }
}